(() => {
  // Keep native validation and add persistent errors linked to their fields.
  // Only storefront-owned forms are enhanced; payment and CAPTCHA frames stay independent.
  let errorIndex = 0;
  document.addEventListener('invalid', event => {
    const field=event.target;
    if (!field.matches('input,select,textarea') || !field.form || !field.form.matches('#ContactForm,.rm-form,.newsletter-form,[data-th-quote-form]')) return;
    if (!field.id) field.id='tth-field-'+(++errorIndex);
    const id=field.id+'-validation-error';
    let error=document.getElementById(id);
    if (!error) {
      error=document.createElement('p'); error.id=id; error.className='tth-field-error';
      (field.closest('.field,.rm-field,.select') || field).insertAdjacentElement('afterend',error);
    }
    const label=field.labels?.[0]?.textContent.replace(/\*/g,'').trim() || 'This field';
    error.textContent=field.validity.valueMissing ? label+' is required.' : field.validity.typeMismatch && field.type==='email' ? 'Enter a valid email address, such as name@example.com.' : field.validationMessage || 'Check this value and try again.';
    field.setAttribute('aria-invalid','true');
    const refs=new Set((field.getAttribute('aria-describedby')||'').split(/\s+/).filter(Boolean));refs.add(id);
    field.setAttribute('aria-describedby',[...refs].join(' '));
  },true);
  document.addEventListener('input',event=>{
    const field=event.target;
    if (!field.matches('input,select,textarea') || !field.validity.valid) return;
    const id=field.id+'-validation-error', error=document.getElementById(id);
    if (!error) return;
    error.remove(); field.removeAttribute('aria-invalid');
    const refs=(field.getAttribute('aria-describedby')||'').split(/\s+/).filter(x=>x&&x!==id);
    if(refs.length)field.setAttribute('aria-describedby',refs.join(' '));else field.removeAttribute('aria-describedby');
  });
  let priceTimer;
  document.addEventListener('change',event=>{
    const picker=event.target.closest('variant-selects,variant-radios');
    if(!picker)return;
    const info=picker.closest('[id^="ProductInfo-"]');if(!info)return;
    clearTimeout(priceTimer);
    priceTimer=setTimeout(()=>{
      const status=info.querySelector('[data-tth-option-status]'), price=info.querySelector('[data-top-price]');
      if(!status||!price)return;
      const choice=[...picker.querySelectorAll('select,input:checked')].map(e=>e.tagName==='SELECT'?e.selectedOptions[0]?.textContent:e.value).filter(Boolean).join(', ');
      const unavailable=info.querySelector('form[action*="/cart/add"] button[type="submit"]')?.disabled;
      status.textContent=choice+'. '+price.textContent.trim()+' '+(info.querySelector('.tth-top-price__currency')?.textContent.trim()||'')+(unavailable?'. Currently unavailable.':'.');
    },500);
  });
})();

(() => {
function connect(root){
root.querySelectorAll(".product__image-thumbnail").forEach(thumbs=>{
if(thumbs.dataset.tthSelectionSync)return;thumbs.dataset.tthSelectionSync="true";let selected;
function sync(){
const active=thumbs.querySelector(".is-nav-selected");if(!active||active===selected)return;selected=active;
thumbs.querySelectorAll(".carousel-cell").forEach(cell=>{if(cell===active)cell.setAttribute("aria-current","true");else cell.removeAttribute("aria-current");});
if(thumbs.classList.contains("flickity-enabled"))return;
const rect=active.getBoundingClientRect(),frame=thumbs.getBoundingClientRect();
thumbs.scrollTo({left:thumbs.scrollLeft+rect.left-frame.left-(frame.width-rect.width)/2,behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"instant":"smooth"});
}
const observer=new MutationObserver(sync);observer.observe(thumbs,{subtree:true,attributes:true,attributeFilter:["class"]});
document.addEventListener("shopify:section:unload",event=>{if(event.target.contains(thumbs))observer.disconnect();});sync();
});
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>connect(document),{once:true});else connect(document);
document.addEventListener("shopify:section:load",event=>connect(event.target));
})();

(() => {
function loadThumbs(root){root.querySelectorAll(".product__image-thumbnail img[data-flickity-lazyload-src]").forEach(img=>{const src=img.getAttribute("data-flickity-lazyload-src"),set=img.getAttribute("data-flickity-lazyload-srcset");img.loading="lazy";if(set){img.srcset=set;img.removeAttribute("data-flickity-lazyload-srcset");}img.src=src;img.removeAttribute("data-flickity-lazyload-src");});}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>loadThumbs(document),{once:true});else loadThumbs(document);
document.addEventListener("shopify:section:load",event=>loadThumbs(event.target));
})();

(() => {
  const drawers = new WeakSet();
  function sync(drawer) {
    const main = drawer.querySelector('.mobile-facets__main');
    if (!main) return;
    let active = false;
    main.querySelectorAll('.mobile-facets__details').forEach(details => {
      const panel = details.querySelector(':scope > .mobile-facets__submenu');
      if (!panel) return;
      const open = details.hasAttribute('open');
      panel.classList.toggle('tth-panel-parked', !open);
      panel.hidden = !open;
      panel.inert = !open;
      panel.style.setProperty('display', open ? 'flex' : 'none', 'important');
      panel.style.setProperty('opacity', open ? '1' : '0', 'important');
      details.classList.toggle('tth-filter-active', open);
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
      active = active || open;
    });
    main.classList.toggle('tth-filter-panel-open', active);
  }
  function setup() {
    document.querySelectorAll('menu-drawer.mobile-facets__wrapper').forEach(drawer => {
      if (drawers.has(drawer) || typeof drawer.closeMenuDrawer !== 'function') return;
      drawers.add(drawer);
      const close = drawer.closeMenuDrawer;
      drawer.closeMenuDrawer = function(event, ...args) {
        if (event && event.type === 'focusout') return;
        return close.call(this, event, ...args);
      };
      new MutationObserver(() => sync(drawer)).observe(drawer, {subtree:true, childList:true, attributes:true, attributeFilter:['open']});
      sync(drawer);
    });
  }
  function back(details) {
    const drawer = details.closest('menu-drawer');
    const root = drawer?.querySelector('details');
    const summary = details.querySelector(':scope > summary');
    if (!root || !summary) return;
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    const panel = details.querySelector(':scope > .mobile-facets__submenu');
    if (panel) {
      panel.classList.add('tth-panel-parked');
      panel.style.setProperty('display', 'none', 'important');
      panel.style.setProperty('opacity', '0', 'important');
      panel.getBoundingClientRect();
    }
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    sync(drawer);
    if (typeof trapFocus === 'function') trapFocus(root, summary);
    else summary.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('.mobile-facets__submenu > .mobile-facets__close-button');
    const summary = event.target.closest('.mobile-facets__details > summary');
    if (!button && !summary) return;
    const details = (button || summary).closest('.mobile-facets__details');
    const panel = details?.querySelector(':scope > .mobile-facets__submenu');
    if (!panel) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button || details.open) return back(details);
    const drawer = details.closest('menu-drawer');
    drawer.querySelectorAll('.mobile-facets__details[open]').forEach(other => {
      other.removeAttribute('open');
      other.classList.remove('menu-opening');
    });
    details.setAttribute('open','');
    details.classList.add('menu-opening');
    sync(drawer);
    const target = panel.querySelector('.mobile-facets__close-button');
    if (typeof trapFocus === 'function') trapFocus(panel, target);
    else target?.focus({preventScroll:true});
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key !== 'Escape') return;
    if (event.target.matches('.mobile-facets__sort select')) {
      event.stopImmediatePropagation();
      return;
    }
    const details = event.target.closest('.mobile-facets__details[open]');
    if (!details) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    back(details);
  }, true);
  customElements.whenDefined('menu-drawer').then(setup);
  document.addEventListener('shopify:section:load', setup);
})();

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('pointerdown', event => {
    if (event.target.closest('.dtm-hero-dots button, .dtm-rotation-toggle')) event.stopPropagation();
  }, true);
  function init() {
    document.querySelectorAll('.mega-menu-talavera--v2[data-dtm-menu]').forEach(root => {
      if (root.dataset.tthRotationReady) return;
      const frame = root.querySelector('.dtm-hero-frame');
      const hero = root.querySelector('.dtm-hero');
      const dots = [...root.querySelectorAll('.dtm-hero-dots button')];
      const slides = [...root.querySelectorAll('.dtm-hero-slide')];
      if (!frame || slides.length < 2 || !dots.length) return;
      root.dataset.tthRotationReady = 'true';
      let paused = reduced.matches;
      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'dtm-rotation-toggle';
      frame.append(control);
      function label() {
        control.textContent = paused ? 'Play' : 'Pause';
        control.setAttribute('aria-label', paused ? 'Start featured collection rotation' : 'Pause featured collection rotation');
      }
      function sync() {
        const products = hero.classList.contains('is-products-active');
        slides.forEach((slide, index) => {
          const active = slide.classList.contains('is-active');
          slide.setAttribute('aria-hidden', String(!active || products));
          slide.tabIndex = active && !products ? 0 : -1;
          dots[index]?.setAttribute('aria-current', String(active));
        });
      }
      control.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        paused = !paused;
        label();
      });
      frame.addEventListener('focusin', event => {
        if (event.target === control) return;
        paused = true;
        label();
      });
      dots.forEach(dot => dot.addEventListener('click', event => {
        if (event.isTrusted) { paused = true; label(); }
        sync();
      }));
      reduced.addEventListener('change', () => { if (reduced.matches) { paused = true; label(); } });
      new MutationObserver(sync).observe(hero, {subtree:true,attributes:true,attributeFilter:['class']});
      setInterval(() => {
        const menu = root.closest('details');
        if (paused || reduced.matches || document.hidden || window.innerWidth < 990 || !menu?.open || hero.classList.contains('is-products-active') || frame.matches(':hover')) return;
        const index = slides.findIndex(slide => slide.classList.contains('is-active'));
        dots[(index + 1) % dots.length].click();
      }, 6000);
      label();
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(init, 0), {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
